import javascript from "refractor/javascript";
export default javascript;